import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";
const initialState = {
  data: null,
  loading: true,
  error: null,
};

const Dashboardstatus = createSlice({
  name: "allstatus",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

// Actions
export const { requestStart, ApiSuccess, requestFailure } =
  Dashboardstatus.actions;

export const DashboardStatus = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(
      `/private/backend/admin?${generateQueryParams(data)}`
    );
    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};
export const DashboardPOSTStatus = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.post(`/private/backend/admin`, data);
    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default Dashboardstatus.reducer;
